export const SubscriptionManagementTargetMap = {
  Subscription_Management_Help_Email_Click:
    "Subscription_Management_Help_Email_Click", // Subscription页底部文案点击Julia邮箱
  Subscription_Management_Help_Link_Click:
    "Subscription_Management_Help_Link_Click", // Subscription页底部文案点击manage your subscription
  Subscription_Management_Popup_Display:
    "Subscription_Management_Popup_Display", // Subscription Management弹窗展示
  Subscription_Management_Popup_Hide:
    "Subscription_Management_Popup_Hide", // Subscription Management弹窗关闭
  Subscription_Management_LearnMore_FindEmails_Click:
    "Subscription_Management_LearnMore_FindEmails_Click", // 未尝试功能点击Find Emails Learn More
  Subscription_Management_LearnMore_FindPhoneNumbers_Click:
    "Subscription_Management_LearnMore_FindPhoneNumbers_Click", // 未尝试功能点击Find Phone Numbers Learn More
  Subscription_Management_LearnMore_FindLeads_Click:
    "Subscription_Management_LearnMore_FindLeads_Click", // 未尝试功能点击Find Leads Learn More
  Subscription_Management_LearnMore_FindAnyWebsite_Click:
    "Subscription_Management_LearnMore_FindAnyWebsite_Click", // 未尝试功能点击Find on Any Website Learn More
  Subscription_Management_ManageBilling_Click:
    "Subscription_Management_ManageBilling_Click", // Subscription Management弹窗点击Manage Billing
  Subscription_Management_ChangePlan_Click:
    "Subscription_Management_ChangePlan_Click", // Subscription Management弹窗点击Change Plan
  Subscription_Management_CancelEntry_Click:
    "Subscription_Management_CancelEntry_Click", // Subscription Management弹窗点击Cancel Subscription入口
  Subscription_Cancel_Reason_Popup_Display:
    "Subscription_Cancel_Reason_Popup_Display", // 取消订阅原因弹窗展示
  Subscription_Cancel_Reason_Back_Click:
    "Subscription_Cancel_Reason_Back_Click", // 取消订阅原因弹窗点击Back或关闭返回管理弹窗
  Subscription_Cancel_Reason_Submit_Click:
    "Subscription_Cancel_Reason_Submit_Click", // 取消订阅原因弹窗提交原因
  Subscription_Cancel_Coupon_Popup_Display:
    "Subscription_Cancel_Coupon_Popup_Display", // 取消订阅挽留优惠券弹窗展示
  Subscription_Cancel_Coupon_Redeem_Click:
    "Subscription_Cancel_Coupon_Redeem_Click", // 挽留优惠券弹窗点击Redeem 50% off & Stay
  Subscription_Cancel_Coupon_Continue_Click:
    "Subscription_Cancel_Coupon_Continue_Click", // 挽留优惠券弹窗点击Continue to Cancel
  Subscription_Cancel_Success_Popup_Display:
    "Subscription_Cancel_Success_Popup_Display", // 取消订阅成功弹窗展示
  Subscription_Cancel_Success_Done_Click:
    "Subscription_Cancel_Success_Done_Click", // 取消订阅成功弹窗点击Done
  one_time_renewal_guide_subscription_contact_click:
    "one_time_renewal_guide_subscription_contact_click", // 一次性续费引导-Subscription页点击联系客服
  one_time_renewal_guide_subscription_contact_modal_show:
    "one_time_renewal_guide_subscription_contact_modal_show", // 一次性续费引导-Subscription页打开联系客服弹窗
  one_time_renewal_guide_subscription_contact_modal_close:
    "one_time_renewal_guide_subscription_contact_modal_close", // 一次性续费引导-Subscription页关闭联系客服弹窗
  one_time_renewal_guide_subscription_cs_whatsapp_click:
    "one_time_renewal_guide_subscription_cs_whatsapp_click", // 一次性续费引导-Subscription页联系客服弹窗-点击添加WhatsApp
  one_time_renewal_guide_subscription_cs_wechat_click:
    "one_time_renewal_guide_subscription_cs_wechat_click", // 一次性续费引导-Subscription页联系客服弹窗-点击添加微信
  bone_time_renewal_guide_subscription_cs_email_open_click:
    "bone_time_renewal_guide_subscription_cs_email_open_click", // 一次性续费引导-Subscription页联系客服弹窗-点击打开本地邮箱
  one_time_renewal_guide_subscription_cs_email_copy_click:
    "one_time_renewal_guide_subscription_cs_email_copy_click", // 一次性续费引导-Subscription页联系客服弹窗-点击复制邮箱
};
